import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_f0fbd5c7: FaireBrandEntity = {
  token: "b_f0fbd5c7",
  type: "brand",
  name: "JaxKelly",
  avatarUrl:
    "https://cdn.faire.com/fastly/a1a57c73a556ee5cd6239ef0090af187daf79b6a8efa27db41bb12c008eaa75c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/406df19c968828111e0d5d8108355646f584f7b00e417a8dc27e54dbfaf9755d.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a1a57c73a556ee5cd6239ef0090af187daf79b6a8efa27db41bb12c008eaa75c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/406df19c968828111e0d5d8108355646f584f7b00e417a8dc27e54dbfaf9755d.png",
  location: "San Diego, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 738,
  isTopShop: true,
  isInsider: true,
  description:
    "Founded in 2014, JaxKelly is a woman-owned brand based in San Diego, led by founder Kelly Decker and a small but passionate team. What started with Kelly handcrafting pieces in her apartment has grown into a modern brand carried by retailers nationwide—yet our heart remains rooted in small-batch care and meaningful design.\n\nFrom our cult-favorite Shower Affirmation Packs (one sells every 19 minutes) to our gold-plated jewelry, every product is designed to empower, uplift, and inspire daily rituals of confidence and connection. With a proven sell-through rate and pricing built to protect your margins, we’re proud to create pieces your customers will love—and to be a partner you can count on.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:14.004Z",
    importedBy: "entity-db-cli",
  },
};
